import React, { useContext, useEffect } from 'react';
import { MenuContext } from 'src/context/MenuContext';
import Header from "src/components/common/Header";
import ProjectForm from "src/components/project/ProjectForm";
import { useParams, useNavigate } from "react-router-dom";
import Menu from "src/components/common/Menu";
import ScrollTop from 'src/components/common/ScrollTop';

export default function UserInput() {
    const containerStyle = { width: "90%", margin: "0 auto" };
    const navigate = useNavigate();
    const { id } = useParams();

    // Destructuring correctly from menuContext
    const { visibleMenu} = useContext(MenuContext);

    const clickProjectListBtn = () => {
        navigate('/projectList');
    }
    return (
        <>
            {visibleMenu && <Menu />}
            <div className={visibleMenu ? 'menu-open' : 'menu-closed'}>
                <Header sx={{ mb: 500 }} />
                <section className="container-fluid contents-top user_input">
                    <div className="text-right">
                        <button type="button" className="btn btn-default" onClick={clickProjectListBtn}>
                            <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                            Back to List
                        </button>
                    </div>
                    <div style={containerStyle}>
                        <h3 className="title-style01">New Project Registration</h3>
                        <ProjectForm id={id} />
                    </div>
                </section>
            </div>
            <ScrollTop/>
        </>
    );
}
